import React, { useContext } from 'react';
import { includes, isEmpty } from 'lodash';
import { Link } from './styles/Link.styled';
import { Container } from './styles/Container.styled';
import { SectionHeadline } from './styles/SectionHeadline.styled';
import ImageCards from './ImageCards';
import { OrganizeEventCard } from './styles/OrganizeEvent.styled';
import { LoadMoreHdn, ViewAllLink } from './styles/LoadMoreButton.styled';
import { DWTCContext } from '../utils/context';
import Sprites from './Sprites';

export default function ImageCardsCarousel({ data, id, dir }) {
  const { title, text, imageCards, link, backgroundColor, regularLink } = data;
  const { cssClass } = useContext(DWTCContext);

  const getTheme = () => {
    if (includes(cssClass, 'free-zone')) return '#ce445b';
    if (includes(cssClass, 'real-estate')) return '#1ba39c';
    return '#1b7bdd';
  };

  let topLink;
  let btnLink;

  if (regularLink) {
    topLink = (
      <Link color={getTheme()} className="home_link view_all" to={link.url} dir={dir}>
        <p>{link.name}</p> <Sprites name="arrow" className="arrow" />
      </Link>
    );
  }

  if (!regularLink) {
    btnLink = isEmpty(link) || (
      <LoadMoreHdn className="cta_btn">
        <ViewAllLink href={link.url} dir={dir}>
          {link.name}
        </ViewAllLink>
      </LoadMoreHdn>
    );
  }

  return (
    <OrganizeEventCard
      className={`${cssClass}`}
      backgroundColor={backgroundColor}
      id={id}
      dir={dir}
    >
      <Container>
        <SectionHeadline className="venueorganise_heading" dir={dir}>
          <h2 dir={dir}>{title}</h2>
          <p dir={dir}>{text}</p>
          {topLink}
        </SectionHeadline>
      </Container>
      <ImageCards data={imageCards} dir={dir} />
      {btnLink}
    </OrganizeEventCard>
  );
}
